import { MyRole } from '$/GraphQL/schema/types';

export const companyRoles = [
  'CEO/Founder',
  'Customer Success',
  'Marketing',
  'Sales',
  'Training/Operations',
  'Other',
];

export const roleOptions = [
  { value: MyRole.Admin, text: MyRole.Admin },
  { value: MyRole.Creator, text: MyRole.Creator },
  { value: MyRole.Editor, text: MyRole.Editor },
  { value: MyRole.Moderator, text: MyRole.Moderator },
  { value: MyRole.Presenter, text: MyRole.Presenter },
];
